import {
    VehicleDetailsLookupResult,
    VehicleDetailsTransportResponse,
} from '../types';

export const normalizeRegistrationNumber = (value: string): string =>
    value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

export const massageVehicleDetailsResponse = (
    response: VehicleDetailsTransportResponse | null | undefined
): VehicleDetailsLookupResult => {
    const details = response?.data;
    if (!details) {
        return {
            text: response?.text ?? null,
            car_details: null,
            error: response?.code ?? response?.error ?? null,
        };
    }

    const registrationMonth = Number(details.registration_month);

    return {
        text: response.text ?? null,
        car_details: {
            registration_number: details.registration_number ?? '',
            acko_make_id: String(details.make_id ?? ''),
            acko_model_id: Number(details.model_id ?? 0),
            make_name: details.make ?? '',
            model_name: details.model ?? '',
            fuel_type: details.fuel_type ?? '',
            color: details.color ?? '',
            registration_year: String(details.registration_year ?? ''),
            registration_month:
                registrationMonth >= 1 && registrationMonth <= 12
                    ? registrationMonth
                    : undefined,
            car_age: details.car_age ?? undefined,
            variant_name: details.variant ?? '',
            acko_variant_id: Number(details.variant_id ?? 0),
        },
        error: response.code ?? response.error ?? null,
    };
};
